import { render } from "./change-log.vue?vue&type=template&id=15122c7a&scoped=true&ts=true"
import script from "./change-log.vue?vue&type=script&lang=ts"
export * from "./change-log.vue?vue&type=script&lang=ts"

import "./change-log.vue?vue&type=style&index=0&id=15122c7a&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15122c7a"]])

export default __exports__